/* https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API */
import { useState, useEffect } from 'react'

export function isDocumentFocused() {
  return document?.hasFocus ? document?.hasFocus() : false
}

export function usePageIsFocused() {
  const [isVisible, setIsVisible] = useState(document?.hasFocus())

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(document?.hasFocus())
    }, 500)

    return () => {
      clearInterval(intervalId)
    }
  }, [setIsVisible])
  return isVisible
}
